<template>

    <div id="dictConfigure">

        <div class="header">
            <!-- 面包屑导航 -->
            <el-breadcrumb style="flex: auto;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>下拉字典</el-breadcrumb-item>
            </el-breadcrumb>

            <el-button size="small" type="primary" icon="el-icon-plus" @click="btnAddChildLevel('',0)">添加</el-button>
        </div>

        <div class="content">

            <el-table :data="dictList" height="100%" border style="width: 100%">
                <el-table-column prop="id" label="ID" width="180">
                </el-table-column>
                <el-table-column prop="name" label="名称" width="180">
                </el-table-column>
                <el-table-column  prop="createTime" label="创建时间">
                    <template slot-scope="scope">
                        <div>{{ transformDate(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="310">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row,2)">详情</el-button>
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row,3)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row,4)">删除</el-button>
                        <el-button size="mini" type="primary" @click="btnAddChildLevel(scope.row,1)">添加</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 添加，编辑 -->
        <el-dialog title="添加" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
            <el-form ref="form" :model="formData" :rules="formRules" label-width="80px">
                <el-form-item label="名称" required>
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="描述信息">
                    <el-input type="textarea" v-model="formData.description"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="btnSureDict">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->

        <el-drawer
        title="详情"
        :visible.sync="drawerVisible"
        size="60%"
        :with-header="false">
        <el-table :data="childList" height="100%" border style="width: 100%">
                <el-table-column prop="id" label="ID" width="180">
                </el-table-column>
                <el-table-column prop="name" label="名称" width="180">
                </el-table-column>
                <el-table-column  prop="createTime" label="创建时间">
                    <template slot-scope="scope">
                        <div>{{ transformDate(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row,5)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row,6)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>

        
    </div>

</template>

<script>
import { addDictApi ,dictListApi ,childListApi, editDictApi , delDictApi } from "@/api/room_admin"
export default {
    data() {
        return {
            dialogVisible: false,
            drawerVisible: false,
            formData: {
                name: '',
                description: ''
            },
            formRules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
            },
            dictList: [], // 字典列表
            childList: [], // 
            operateType: 0, // 操作类型
            temporaryObj: '', // 临时数据
        }
    },
    mounted() {
        this.dictListData()
    },
    methods: {
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        // 确定添加字典
        btnSureDict(){
            this.dialogVisible = false
            if (this.operateType == 0) {
                addDictApi({
                    is_selectable: 1,
                    ...this.formData
                }).then(res =>{
                    if (res.code == 0) {

                    }
                })
            }else if (this.operateType == 1) {
                addDictApi({
                    is_selectable: 1,
                    configId: this.temporaryObj.id,
                    ...this.formData
                }).then(res =>{
                    if (res.code == 0) {

                    }
                })
            }else if (this.operateType == 3) {
                editDictApi({
                    id: this.temporaryObj.id,
                    ...this.formData
                }).then(res =>{
                    if (res.code == 200) {
                        this.dictListData()
                    }
                })
            }else if (this.operateType == 5) {
                editDictApi({
                    id: this.temporaryObj.id,
                    configId: this.temporaryObj.configId,
                    ...this.formData
                }).then(res =>{
                    if (res.code == 200) {
                        childListApi({
                            id: this.temporaryObj.configId
                        }).then(res =>{
                            if (res.code == 200) {
                                this.childList = res.data.list
                            }
                        })
                    }
                })
                
            }
            
        },
        // 点击子级
        btnAddChildLevel(data,type){
            this.dialogVisible = true
            this.temporaryObj = data
            this.operateType = type
            // let that = this
            this.formData.name = ''
            this.formData.description = ''
           
        },
        // 操作按钮
        btnOperate(item,type){
            let that = this
            this.operateType = type
            if (type == 2) {
                this.temporaryObj = item
                childListApi({
                    id: item.id
                }).then(res =>{
                    if (res.code == 200) {
                        this.drawerVisible = true
                        this.childList = res.data.list
                    }
                })
            }else if (type == 3) {
                this.dialogVisible = true
                this.temporaryObj = item
                this.formData.name = item.name
                this.formData.description = item.description
            }else if (type == 4 || type == 6){
                this.temporaryObj = item
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    delDictApi({
                        id: item.id
                    }).then(res =>{
                        if (res.code == 200) {
                            if (type == 4) {
                                this.dictListData()
                            }else if (type == 6) {
                                childListApi({
                                    id: that.temporaryObj.configId
                                }).then(res =>{
                                    if (res.code == 200) {
                                        that.childList = res.data.list
                                    }
                                })
                            }
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })
                    
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
                });
                
            } else if (type == 5) {
                this.dialogVisible = true
                this.temporaryObj = item
                this.formData.name = item.name
                this.formData.description = item.description
            }
            
        },
        // 字典列表
        dictListData(){
            let that = this
            dictListApi({

            }).then(res =>{
                if (res.code == 200) {
                    that.dictList = res.data.list
                }
                
            })
        }
    }
}

</script>

<style scoped>
#dictConfigure {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
}

#dictConfigure .header {
    flex: none;
    height: 40px;
    display: flex;
    align-items: center;
    align-content: space-between !important;
}

#dictConfigure .content {
    flex: auto;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/dict_configure/dict.vue